//==========================================
//⚠️ Keep index files under 100 lines!
//Split logic into submodules as needed.
//==========================================
import { Tooltip } from "@mui/material";
import { BreadcrumbItem, Breadcrumbs } from "@vds/breadcrumbs";
import { Button } from "@vds/buttons";
import { Checkbox } from "@vds/checkboxes";
import { Icon } from "@vds/icons";
import { Input } from "@vds/inputs";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemSubtitle,
  ListGroupItemTitle,
} from "@vds/lists";
import { Loader } from "@vds/loaders";
import { DropdownSelect } from "@vds/selects";
import { Body, Title } from "@vds/typography";
import { Spin } from "antd";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  addBillingAccountUser,
  cancelInvitationEndPoint,
  fetchNotificationGroupsEndPoint,
  getUsersList,
  removeBillingAccountUser,
  updateNotificationUsersEndPoint,
  updateMdnNotificationUsersEndPoint,
  updateOtpNotificationUsersEndPoint
} from "../../../src/configuration";
import { ReactComponent as PlusButtonIcon } from "../../assets/PlusButtonIcon.svg";
import axiosInstance from "../../global/axiosInterceptor";
import { hasPermission } from "../../global/utility/permissionUtils";
import RemoveGroupModal from "./RemoveGroupModal";
import RemoveSiteModal from "./RemoveSiteModal";
import AddGroupModal from "./AddGroupModal";
import CancelModal from "./CancelModal";
import UsersOnBillingAccountModal from "./UsersOnBillingAccountModal";
import {
  getDisplayPhoneNumber,
  getFormatedContactNumber,
  handleApiError,
  isInvalidContactNumber,
  validateEmail,
} from "../../global/utility/Utils";
import {
  addRole,
  getRoleByUser,
  getRoles,
  getUserSites,
  revokeRole,
  updateUserToGroups,
} from "../../model/roleService";
import { inviteUser, reinviteUser, removeUsersToExistingGroup } from "../../pages/UserGroups/userGroupsService";
import {
  roleList as allRolesList,
  showNotificationBanner,
  setUserActiveSession,
  userRoleList as updateUserRoleList,
  fetchCountryIdsRequest
} from "../../store/actions";
import { showAggregatedNotification } from "../../global/utility/notificationHelpers";
import "../../styles/deviceStyle.css";
import "./users.css";
import { fetchBillingAccountsData } from "../Licenses/LicensesServices";
import { ResendInviteModal } from "../UserGroups/UserGroupsModals";
import OTPVerificationModal from "./OTPVerificationModal";
import { INVITE_USER_ERROR_MESSAGES, TAB_NAMES, USER_ROLE, isUserNonAdmin } from "../../global/constants/constants";
import { ROUTES } from "../../global/constants/routesConstants";
import { USER_UPDATE_ERROR, INVITE_RESENT_SUCCESS, USER_DETAILS_UPDATED_SUCCESS, USER_DETAILS_UPDATE_FAILED, USER_DETAILS_UPDATED, GROUPS_SITES_UPDATE_FAILED, FAILED_TO_SEND_OTP, FAILED_TO_RESEND_INVITE, PHONE_UPDATE_SUCCESS, INVALID_OTP_ERROR, NON_NUMERIC_REGEX } from "../../global/constants/otpConstants";
import {
  USER_DETAILS_TOOLTIP_EDIT_OWN_PROFILE,
  USER_DETAILS_BUTTON_EDIT,
  USER_DETAILS_BUTTON_SAVE,
  USER_DETAILS_BUTTON_RESEND_INVITE,
  USER_DETAILS_LINK_VIEW_USERS_ON_ACCOUNT,
  USER_DETAILS_FIELD_FIRST_NAME,
  USER_DETAILS_FIELD_LAST_NAME,
  USER_DETAILS_FIELD_PHONE_NUMBER,
  USER_DETAILS_FIELD_ROLE,
  USER_DETAILS_FIELD_SITES,
  USER_DETAILS_FIELD_GROUPS,
  GROUP_REMOVAL_FAILED,
  GROUP_REMOVED_SUCCESS_PREFIX,
  GROUP_REMOVED_SUCCESS_MIDDLE,
  GROUP_REMOVED_SUCCESS_SUFFIX,
  SITES_AND_GROUPS_SECTION_TITLE_PREFIX,
  SITES_AND_GROUPS_SECTION_TITLE_SUFFIX,
  USER_DETAILS_UPDATE_SUCCESS_SUFFIX,
  USER_DETAILS_UPDATE_FAILED_PREFIX,
  ADD_GROUP_TOOLTIP,
  ADD_GROUP_SETTINGS_TOOLTIP,
  DELETE_SITE_TOOLTIP,
  DELETE_SITE_NO_PERMISSION_TOOLTIP,
  DELETE_SITE_NO_AUTH_TOOLTIP,
  DEFAULT_SITE_LABEL,
  DEFAULT_GROUP_LABEL,
  NAVIGATION_DELAY,
  PROMISE_STATUS_FULFILLED,
  USER_DETAILS_UPDATE_ERROR,
  RESEND_INVITE_SUCCESS_MESSAGE,
  RESEND_INVITE_ERROR_MESSAGE,
  INVALID_EMAIL_ERROR_MESSAGE,
  NOTIFICATION_TYPE_RESEND_INVITE,
  NOTIFICATION_TYPE_INVITE_SENT,
  NOTIFICATION_TYPE_UPDATED_INVITE_SENT,
  NOTIFICATION_TYPE_USER_DETAILS_NOT_UPDATED,
  NOTIFICATION_PRIORITY_SUCCESS,
  NOTIFICATION_PRIORITY_CRITICAL,
  NOTIFICATION_PRIORITY_WARNING,
  PERMISSION_ROLE_MANAGEMENT,
  getIsRoleReadOnly,
  FETCH_USERS_LIST_ERROR,
  getIsNotAdmin,
  isMDNModified,
  BILLING_ACCOUNT_NO_PERMISSION_TOOLTIP,
  MODAL_NAME_ADD_GROUP,
  MODAL_NAME_BILLING,
  MODAL_NAME_CANCEL,
  MODAL_NAME_REMOVE_GROUP,
  MODAL_NAME_REMOVE_SITE,
  MODAL_NAME_OTP,
  MODAL_CANCEL_BUTTON,
} from "../../global/constants/userDetailsConstants";
import { notificationTypes } from "../../layouts/NotificationConfig";

const UserDetails = () => {
  let navigate = useNavigate();
  const [isEditable, setisEditable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isInputTouched, setIsInputTouched] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const location = useLocation();
  const { state } = location;
  const [rolesList, setRolesList] = useState([]);
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  const { errorType } = useSelector((state) => state.errorReducer);
const [showOTPModal, setShowOTPModal] = useState(false);
const [otpLoading, setOTPLoading] = useState(false);
const [pendingMDNData, setPendingMDNData] = useState(null);

  const user = (() => {
    const data =
      JSON.parse(sessionStorage.getItem("accountDetails"));
    return data;
  })();
  const role = JSON.parse(sessionStorage.getItem("selectedRole"));
  const dispatch = useDispatch();
  const { register, control, handleSubmit, setValue, watch, reset } = useForm({
    defaultValues: {
      firstname: state?.firstname || user?.firstname,
      lastname: state?.lastname || user?.lastname,
      mdn: state?.mdn || user?.mdn,
      sites: [],
      role: state?.customdata?.roles[0]?.name,
      email: state?.email || user?.email,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "sites",
  });
  const [showNotificationPopup, setShowNotificationPopup] = useState({
    message: "",
    show: false,
    type: "",
    title: "",
  });
  const ref = useRef();
  const userCurrentRoleRef = useRef();
  const [showNotification, setShowNotification] = useState(false);
  const isPendingUser = state?.tabName === "Pending Invites";
  const [showResendModal, setShowResendModal] = useState(false);
  const [bannerData, setBannerData] = useState("");
  const [bannerType, setBannerType] = useState(null);
  const [invalidPhoneNum, setInvalidPhoneNum] = useState(false);


  const [userSites, setUserSites] = useState([]);
  const [loginUserSites, setLoginUserSites] = useState([]);
  const [noAdminSites, setNoAdminSites] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);
  const [dropDownSites, setDropDownSites] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [selectedRole, setSelectedRole] = useState(state?.role || state?.customdata?.roles?.[0]?.name || "");
  const [existingGroups, setExistingGroups] = useState([]);
  const [newGroups, setNewGroups] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Efficient modal key management - single state object instead of 6 separate counters
  const [modalKeys, setModalKeys] = useState({
    [MODAL_NAME_ADD_GROUP]: 0,
    [MODAL_NAME_BILLING]: 0,
    [MODAL_NAME_CANCEL]: 0,
    [MODAL_NAME_REMOVE_GROUP]: 0,
    [MODAL_NAME_REMOVE_SITE]: 0,
    [MODAL_NAME_OTP]: 0
  });

  // Memoized callback to reset a specific modal
  const resetModal = useCallback((modalName) => {
    setModalKeys(prev => ({
      ...prev,
      [modalName]: prev[modalName] + 1
    }));
  }, []);

  const [users, setUser] = useState([]);
  const [selectedAccountId, setSelectedAccountId] = useState(false);
  const [pendingUserInitialized, setPendingUserInitialized] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [billingAccounts, setBillingAccounts] = useState([]);
  const accID = sessionStorage.getItem("accountId");
  const [userRoleList, setUserRoleList] = useState([]);
  const initialRoleId = (state?.customdata?.roles?.[0]?.id && typeof state.customdata.roles[0].id === "string") ? state.customdata.roles[0].id : "";
  const [previousRoleId, setPreviousRoleId] = useState(initialRoleId);
  const [selectedRoleId, setSelectedRoleId] = useState(initialRoleId);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [removeSites, setRemoveSites] = useState([]);

  const [refreshUsersTable, setRefreshUsersTable] = useState(false);
  const [trashedSites, setTrashedSites] = useState([]);
  const [showRemoveGroupModal, setShowRemoveGroupModal] = useState(false);
  const [groupToRemove, setGroupToRemove] = useState(null);
  const [showRemoveSiteModal, setShowRemoveSiteModal] = useState(false);
  const [siteToRemove, setSiteToRemove] = useState(null);
  const [isSitesLoading, setIsSitesLoading] = useState(true);
  const [isDataInitialized, setIsDataInitialized] = useState(false);

  // Extract user ID from state: handles both direct (state.id) and nested (state.userDetails.id) structures
  const currentUserId = state?.userDetails?.id || state?.id || activeSession?.userId;
  const isEditingOwnProfile = currentUserId && currentUserId === activeSession?.userId;

  const originalValuesRef = useRef({
    firstname: state?.firstname || state?.userDetails?.firstname || "",
    lastname: state?.lastname || state?.userDetails?.lastname || "",
    email: state?.email || state?.userDetails?.email || "",
    mdn: state?.mdn || state?.userDetails?.mdn || ""
  });

  const isCurrentUserNonAdmin = useMemo(() => {
    return isUserNonAdmin(currentUserRole);
  }, [currentUserRole]);

  /* Determines the readOnly and disabled state for name fields (firstname/lastname).Returns an object with { readOnly: boolean, disabled: boolean } */
  const getNameFieldState = () => {
    if (!isEditable) {
      return { readOnly: true, disabled: false };
    }

    // Site managers/viewers can edit their own names
    if (isCurrentUserNonAdmin) {
      return { readOnly: false, disabled: false };
    }

    // Admins cannot edit their own names
    if (isEditingOwnProfile) {
      return { readOnly: true, disabled: true };
    }

    // Default: Admins can edit other users' names
    return { readOnly: false, disabled: false };
  };

  /* Determines the readOnly and disabled state for phone number field. Returns an object with { readOnly: boolean, disabled: boolean } */
  const getPhoneFieldState = () => {
    // Case 1: Form is not in edit mode - field is read-only but not disabled
    if (!isEditable) {
      return { readOnly: true, disabled: false };
    }
    
    // Case 2: Viewing another user's profile (not a pending user) - cannot edit their phone
    if (!isEditingOwnProfile && !isPendingUser && state?.id) {
      return { readOnly: true, disabled: true };
    }
    
    // Case 3: Admin viewing their own profile - admins cannot edit their own phone number
    if (isEditingOwnProfile && !isCurrentUserNonAdmin) {
      return { readOnly: true, disabled: true };
    }
    
    // Default: Field is fully editable
    // Note: Non-admins (Site Manager/Site Viewer) can edit their own phone number
    return { readOnly: false, disabled: false };
  };

  const { siteTagList } = useSelector((state) => state?.sitesReducer);
  const { roleList, userRole } = useSelector((state) => state?.userRoleReducer);

  const getUserDataForInvite = () => {
    const email = formValues?.inviteeemail || formValues?.email || state?.Email;
    const firstname = formValues?.inviteefirstname || formValues?.firstname || state?.firstname || '';
    const lastname = formValues?.inviteelastname || formValues?.lastname || state?.lastname || '';
    const mdn = formValues?.mdn || state?.mdn || '';
    const role = selectedRoleId || state?.roleid || state?.role || '';
    const tagids = fields?.map(site => site.id) || state?.siteids || [];
    const billingAccountIds = state?.billingaccountids || [activeSession?.accountId] || [];
    
    return {
      firstname,
      lastname,
      email,
      mdn: mdn || '',
      role,
      tagids,
      billingAccounts: billingAccountIds,
    };
  };
  const getUserDataFromSubmittedForm = (formData) => {
    const email = formData?.inviteeemail || formData?.email || state?.Email || state?.inviteeemail;
    const firstname = formData?.inviteefirstname || formData?.firstname || state?.firstname || '';
    const lastname = formData?.inviteelastname || formData?.lastname || state?.lastname || '';
    const mdn = formData?.mdn || state?.mdn || '';
    let role = selectedRoleId || state?.roleid || state?.role || '';
    if (!selectedRoleId && formData?.role) {
      const foundRole = rolesList.find(r => r.name === formData.role);
      role = foundRole ? foundRole.id : formData.role;
    }
    const tagids = fields?.map(site => site.siteId) || [];
    const billingAccountIds = state?.assignment?.billingaccountids || [activeSession?.accountId] || [];
    let cleanedMdn = mdn;
    if (cleanedMdn) {
      cleanedMdn = cleanedMdn.replace(/[^0-9]/g, "");
      if (cleanedMdn.length === 10) {
        cleanedMdn = "+1" + cleanedMdn;
      }
    }
    
    return {
      firstname,
      lastname,
      email,
      mdn: cleanedMdn || '',
      role,
      tagids,
      billingAccounts: billingAccountIds,
    };
  };

  const handleResendInvite = () => {
    if (!isPendingUser) {
      return;
    }
    setShowResendModal(true);
  };

  const confirmResendInvite = async () => {
    setShowResendModal(false);
    setIsSaving(true);
    try {
      const { email, firstname, lastname } = getUserDataForInvite();
      if (!validateEmail(email)) {
        dispatch(showNotificationBanner({
          type: NOTIFICATION_TYPE_RESEND_INVITE,
          priority: NOTIFICATION_PRIORITY_CRITICAL,
          data: { subTitle: INVALID_EMAIL_ERROR_MESSAGE },
          showNotification: true,
        }));
        return;
      }
      const userId = state?.id || state?.foreignid || state?.userid;
      const userData = getUserDataForInvite();
      const invitePayload = {
        ...userData,
        oldinvitationid: userId
      };
      const inviteResponse = await reinviteUser(invitePayload, activeSession, null, () => {});
      if (!inviteResponse?.wasemailsent) {
        dispatch(showNotificationBanner({
          type: NOTIFICATION_TYPE_INVITE_SENT,
          priority: NOTIFICATION_PRIORITY_SUCCESS,
          data: { subTitle: RESEND_INVITE_SUCCESS_MESSAGE.replace("{firstname}", firstname).replace("{lastname}", lastname) },
          showNotification: true,
        }));
      } else {
        dispatch(showNotificationBanner({
          type: NOTIFICATION_TYPE_RESEND_INVITE,
          priority: NOTIFICATION_PRIORITY_WARNING,
          data: { subTitle: INVITE_USER_ERROR_MESSAGES.failedToSendInvitation },
          showNotification: true,
        }));
      }
    } catch (error) {
      dispatch(showNotificationBanner({
        type: NOTIFICATION_TYPE_RESEND_INVITE,
        priority: NOTIFICATION_PRIORITY_CRITICAL,
        data: { subTitle: RESEND_INVITE_ERROR_MESSAGE },
        showNotification: true,
      }));
    } finally {
      setIsSaving(false);
      navigate(ROUTES.USERGROUPS, {
            state: {
              tabName: TAB_NAMES.PENDING_INVITES,
              fromPage: "UserDetails",
            }
          });
    }
  };

  const handleCancel = () => {
    if (isInputTouched) {
      resetModal(MODAL_NAME_CANCEL);
      setShowCancelModal(true);
    } else {
      navigate(ROUTES.USERGROUPS);
    }
  };

  const confirmCancel = () => {
    setShowCancelModal(false);
    navigate(ROUTES.USERGROUPS);
  };

  const denyCancel = () => {
    setShowCancelModal(false);
  };

  const [showSiteInput, setShowSiteInput] = useState(false);   
  const handleAddSite = () => {
    setShowSiteInput(true);
  };

  const handleSelectSite = (event) => {
    const selectedSite =
      event.target.selectedOptions[0].getAttribute("data-id");
    const siteId = event.target.selectedOptions[0].getAttribute("data-siteId");
    const siteName = event.target.value;
    if (selectedSite && !dropDownSites?.includes(selectedSite)) {
      setSelectedSites([...selectedSites, selectedSite]);
      setDropDownSites([...dropDownSites, selectedSite]);
    }
    const groups = getUserGroupsResponse();
    const siteObj = { groups: [] };
    groups?.forEach((group) => {
      const groupObj = { users: [] };

      if (group?.tagids?.includes(selectedSite)) {
        groupObj["name"] = group?.name;
        groupObj["id"] = group?.id;
        const user = group?.users?.find(
          (user) => user?.id === (state?.id || activeSession?.userId)
        );
        groupObj["users"] = group?.users?.map((user) => {
          return { id: user.id, name: user?.firstname + " " + user?.lastname };
        });
        groupObj["associated"] =
          user?.id === (state?.id || activeSession?.userId);
        groupObj["existingGroup"] =
          user?.id === (state?.id || activeSession?.userId);
      }
      siteObj["siteId"] = selectedSite;
      siteObj["siteName"] = siteName;
      if (
        group?.tagids?.includes(selectedSite) &&
        Object.keys(groupObj).length > 0
      ) {
        siteObj["groups"].push(groupObj);
      }
    });
    append(siteObj);
    setShowSiteInput(false);
    setIsInputTouched(true);
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      setIsLoading(true);
      try {
        const accounts = await fetchBillingAccountsData();
        setBillingAccounts(accounts);
      } catch (error) {
        console.log("Error fetching accounts:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAccounts();
  }, []);

  const userBillingIDs = billingAccounts;

  const [checkedBillingIds, setCheckedBillingIds] = useState(userBillingIDs);

  const handleViewUsersClick = (accountId) => {
    resetModal(MODAL_NAME_BILLING);
    setSelectedAccountId(accountId);
    setIsModalVisible(true);
  };

  const handleCheckboxChange = (billingID) => {
    if (checkedBillingIds.includes(billingID)) {
      setCheckedBillingIds(checkedBillingIds.filter((id) => id !== billingID));
    } else {
      setCheckedBillingIds([...checkedBillingIds, billingID]);
    }
  };

  const toggleEditMode = () => {
    if (isEditMode) {
      saveChanges();
    }
    setIsEditMode(!isEditMode);
  };

  const saveChanges = () => {
    const addedBillingIDs = checkedBillingIds.filter(
      (id) => !userBillingIDs.includes(id)
    );
    const removeBillingIDs = userBillingIDs.filter(
      (id) => !checkedBillingIds.includes(id)
    );

    addedBillingIDs.forEach((id) => addBAID(id));
    removeBillingIDs.forEach((id) => removeBAID(id));
  };

  useEffect(() => {
    if (userBillingIDs) {
      setCheckedBillingIds(userBillingIDs);
    }
  }, [userBillingIDs]);

  useEffect(() => {
    const fetchRolesList = async () => {
      if (roleList && roleList.length > 0) {
        setRolesList(roleList);
      } else {
        try {
          const roles = await getRolesList();
          setRolesList(roles);
        } catch (error) {
          console.error("Error fetching roles:", error);
        }
      }
    };
    fetchRolesList();
  }, [state]);

  const getRolesList = async () => {
    try {
      const response = await getRoles(activeSession);
      dispatch(allRolesList(roleList));
      return response;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const getUserRole = async (shouldUpdatePreviousRoleId = true) => {
    let userList = state?.customdata?.roles;
    if (userList && userList.length > 0) {
      // If userList is not empty, use the user roles data
      userCurrentRoleRef.current = userList[0]?.name;
      setSelectedRole(userList[0]?.name);
      setSelectedRoleId(userList[0]?.id);
      setUserRoleList(userList);
      if (shouldUpdatePreviousRoleId) {
        setPreviousRoleId(userList[0]?.id);
      }
    } else {
      // If userList is empty, fallback to userRole from the userRoleReducer or make API call
      if (userRole) {
        setSelectedRole(userRole);
      } else {
        // If no userRole, call the API to fetch the user role
        const userId = state?.id || activeSession?.userId;
        if (!userId) {
          console.error("Failed to fetch user roles: No user ID available");
          setUserRoleList([]);
          return;
        }
        try {
          const userList = await getRoleByUser(activeSession, userId);
          if (userList && userList.length > 0) {
            userCurrentRoleRef.current = userList[0]?.name;
            setSelectedRole(userList[0]?.name);
            setSelectedRoleId(userList[0]?.id);
            setUserRoleList(userList);
            if (shouldUpdatePreviousRoleId) {
              setPreviousRoleId(userList[0]?.id);
            }
            dispatch(updateUserRoleList(userList));
          }
        } catch (error) {
          console.error("Failed to fetch user roles", error);
          setUserRoleList([]);
        }
      }
    }
  };

  //Fetching users list from API
  useEffect(() => {
    const usersList = async () => {
      try {
        const response = await axiosInstance.post(getUsersList(), {
          accountName: activeSession.accountId,
        });
        const resData = response.data;
        setUser(resData);
        if (response.status === 200) {
          const filteredUsers = resData.filter((user) => user.billingaccountid);
          setUser(filteredUsers);
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.error_description;
        console.log("Error while getting user list -> " + error);
        handleApiError(
          "warning",
          errorMessage
            ? errorMessage
            : FETCH_USERS_LIST_ERROR
        );
        return [];
      }
    };
    usersList();
  }, []);

  //API call to add billing account to user
  const addBAID = async (activeSession, resourceIdentifier, hrefs) => {
    try {
      const response = await axiosInstance.post(addBillingAccountUser(), {
        resourceidentifier: {
          id: resourceIdentifier.id,
        },
        hrefs: hrefs,
      });
      const res = response.data;
      //sessionStorage.setItem("rolePermissionsList",JSON.stringify(res));
      return res;
    } catch (error) {
      console.log("Error while adding billing account -> " + error);
      return null;
    }
  };

  //API call to remove billing account from user
  const removeBAID = async (activeSession, resourceIdentifier, hrefs) => {
    try {
      const response = await axiosInstance.post(removeBillingAccountUser(), {
        resourceidentifier: {
          id: resourceIdentifier.id,
        },
        hrefs: hrefs,
      });
      const res = response.data;
      //sessionStorage.setItem("userList", JSON.stringify(res));
      return res;
    } catch (error) {
      console.log("Error while adding removing account -> " + error);
      return null;
    }
  };

  useEffect(() => {
    let existingGroups =
      fields?.flatMap(
        (site) =>
          site?.groups
            ?.filter((group) => group?.existingGroup === true)
            .map((group) => group?.id) || []
      ) || [];
    existingGroups = [...new Set(existingGroups)];
    setExistingGroups(existingGroups);
  }, [fields]);

  const userAssociatedSites = (sites) => {
    const groups = getUserGroupsResponse();
    const userSites_Mod = [];
    sites?.length > 0 &&
      sites?.forEach((site) => {
        const siteObj = { groups: [] };
        if (!groups || groups?.length <= 0) {
          siteObj["siteId"] = site?.id;
          siteObj["id"] = site?.id;
          siteObj["siteName"] = site?.name;
        }
        groups?.forEach((group) => {
          const groupObj = { users: [] };

          if (group?.tagids?.includes(site.id)) {
            groupObj["name"] = group?.name;
            groupObj["id"] = group?.id;
            const user = group?.users?.find(
              (user) => user?.id === (state?.id || activeSession?.userId)
            );
            groupObj["users"] = group?.users?.map((user) => {
              return {
                id: user.id,
                name: user?.firstname + " " + user?.lastname,
              };
            });
            groupObj["associated"] =
              user?.id === (state?.id || activeSession?.userId);
            groupObj["existingGroup"] =
              user?.id === (state?.id || activeSession?.userId);
          }
          siteObj["siteId"] = site?.id;
          siteObj["id"] = site?.id;
          siteObj["siteName"] = site?.name;
          if (
            group?.tagids?.includes(site?.id) &&
            Object.keys(groupObj).length > 0
          ) {
            siteObj["groups"].push(groupObj);
          }
        });
        if (Object.keys(siteObj).length > 0) {
          userSites_Mod.push(siteObj);
        }
      });
    return userSites_Mod;
  };

  const handleOpenModal = (site) => {
    if (isRestricted()) return;
    resetModal(MODAL_NAME_ADD_GROUP);
    setSelectedSite(site);
    setSelectedGroups(
      site?.groups
        ?.filter((group) => group?.associated)
        ?.map((group) => group?.id)
    );
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedSite(null);
    setSelectedGroups([]);
  };

  const handleGroupSelection = (groupId) => {
    const updatedGroups = [...selectedGroups];

    if (updatedGroups.includes(groupId)) {
      const index = updatedGroups.indexOf(groupId);
      updatedGroups.splice(index, 1);
    } else {
      updatedGroups.push(groupId);
    }
    setSelectedGroups(updatedGroups);
  };

  const handleRemoveGroupClick = (siteId, groupId) => {
    // Find the group name before showing confirmation
    const site = fields?.find((s) => s.siteId === siteId);
    const group = site?.groups?.find((g) => g.id === groupId);

    resetModal(MODAL_NAME_REMOVE_GROUP);
    setGroupToRemove({
      siteId,
      groupId,
      groupName: group?.name || DEFAULT_GROUP_LABEL,
      userName: userName || 'this user'
    });
    setShowRemoveGroupModal(true);
  };

  const confirmRemoveGroup = async () => {
    if (!groupToRemove) return;

    const { siteId, groupId, groupName, userName } = groupToRemove;
    setShowRemoveGroupModal(false);
    setIsSaving(true);

    try {
      const response = await removeUsersToExistingGroup(
        groupId,
        [currentUserId],
        activeSession
      );
      if (response.status === 200) {
        const updatedSites = fields?.map((site) => {
          if (site.siteId === siteId) {
            const updatedGroups = site.groups.map((group) =>
              group.id === groupId ? { ...group, associated: false } : group
            );
            return { ...site, groups: updatedGroups };
          }
          return site;
        });
        setValue("sites", updatedSites);
        setUserSites(updatedSites);
        setSelectedGroups(selectedGroups.filter((id) => id !== groupId));

        // Show success notification with user and group name
        dispatch(showNotificationBanner({
          type: notificationTypes[23],
          priority: NOTIFICATION_PRIORITY_SUCCESS,
          data: {
            subTitle: `${GROUP_REMOVED_SUCCESS_PREFIX} ${userName} ${GROUP_REMOVED_SUCCESS_MIDDLE} ${groupName} ${GROUP_REMOVED_SUCCESS_SUFFIX}`
          },
          showNotification: true,
          autoDismiss: false,
          isDismissible: true
        }));
      } else {
        setValue("sites", fields);

        // Show error notification with API error description if available
        const errorMessage = response?.data?.error_description || GROUP_REMOVAL_FAILED;
        dispatch(showNotificationBanner({
          type: notificationTypes[88],
          priority: NOTIFICATION_PRIORITY_CRITICAL,
          data: {
            subTitle: errorMessage
          },
          showNotification: true,
          autoDismiss: false,
          isDismissible: true
        }));
      }
    } catch (error) {
      console.log("error in remove in group", error);
      setValue("sites", fields);

      // Show error notification with API error description if available
      const errorMessage = error?.response?.data?.error_description || GROUP_REMOVAL_FAILED;
      dispatch(showNotificationBanner({
        type: notificationTypes[88],
        priority: NOTIFICATION_PRIORITY_CRITICAL,
        data: {
            subTitle: errorMessage
          },
          showNotification: true,
          autoDismiss: false,
          isDismissible: true
        }));
    } finally {
      setIsSaving(false);
    }
    setGroupToRemove(null);
  };

  const handleAddSelectedGroups = () => {
    if (selectedSite) {
      const updatedGroups = selectedSite.groups.map((group) => ({
        ...group,
        associated: selectedGroups.includes(group.id),
      }));
      const updatedGroupIds = updatedGroups
        .filter((group) => group.associated)
        .map((group) => group.id);
      let sites = [...fields];
      sites = sites.map((site) =>
        site.siteId === selectedSite.siteId
          ? { ...site, groups: updatedGroups }
          : site
      );
      setNewGroups((prevGroups) => [...prevGroups, ...updatedGroupIds]);
      setValue("sites", sites);
      setUserSites(sites);
      handleCloseModal();
      setIsInputTouched(true);
    }
  };

  const getUserGroupsResponse = () => {
    return JSON.parse(sessionStorage.getItem("userGroupsResponse"));
  };

  const handleCloseRemoveGroupModal = () => {
    setShowRemoveGroupModal(false);
    setGroupToRemove(null);
  };



  const editSiteContent = (groups, site) => {
    const associatedGroups = groups?.filter((group) => group?.associated);
    return (
      <div className="groups-section">
        <p className="groups-label">{USER_DETAILS_FIELD_GROUPS}</p>
        <div className="groups-tags-wrapper">
          {associatedGroups?.length > 0
            ? associatedGroups?.map((group) => (
                <div key={group?.id} className="group-tag">
                  <Tooltip title={group?.name} arrow>
                    <span className="group-tag-text">{group?.name}</span>
                  </Tooltip>
                  <div
                    className="group-tag-icon"
                    data-testid="userdetails_removeGroupButton"
                    onClick={() => handleRemoveGroupClick(site?.siteId, group?.id)}
                  >
                    <Icon name="close" size="small" color="#000000" />
                  </div>
                </div>
              ))
            : null}
          <div className={`button-plus-container ${isRestricted() ? 'disabled' : ''}`}>
            <Tooltip title={isRestricted() ? ADD_GROUP_SETTINGS_TOOLTIP : ADD_GROUP_TOOLTIP} arrow placement="top">
              <span className="tooltip-wrapper">
                <PlusButtonIcon
                  data-testid="userdetails_plusButton"
                  onClick={() => !isRestricted() && handleOpenModal(site)}
                />
              </span>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const notEditSiteContent = (groups) => {
    const associatedGroups = groups?.filter((group) => group?.associated);
    return (
      <div className="groups-section">
        <p className="groups-label">{USER_DETAILS_FIELD_GROUPS}</p>
        <div className="groups-tags-wrapper-readonly">
          {associatedGroups?.length > 0 ? (
            associatedGroups?.map((group) => (
              <div key={group.id} className="group-tag-readonly">
                <Tooltip title={group?.name} arrow>
                  <span className="group-tag-text">{group?.name}</span>
                </Tooltip>
              </div>
            ))
          ) : (
            <p className="no-groups-message">
              User is not currently a part of any groups for this site. Edit user
              <br />
              details to add groups.
            </p>
          )}
        </div>
      </div>
    );
  };

  const renderSitesContent = (isEditable, site) => {
    const groups = site?.groups;
    return (
      <>
        {isEditable
          ? editSiteContent(groups, site)
          : notEditSiteContent(groups)}
      </>
    );
  };

  useEffect(() => {
    const stateRole = state?.customdata?.roles[0]?.name;
    let role = selectedRole !== stateRole ? selectedRole : stateRole;
    const firstname = state?.firstname || state?.inviteefirstname || user?.firstname || user?.inviteefirstname || "";
    const lastname = state?.lastname || state?.inviteelastname || user?.lastname || user?.inviteelastname || "";
    const email = state?.email || state?.inviteeemail || user?.email || user?.inviteeemail || "";
    const initialMdn = state?.mdn || user?.mdn || user?.inviteemdn || state?.inviteemdn;

    setValue("firstname", firstname);
    setValue("lastname", lastname);
    setValue("email", email);

    let formattedMdn = "";
    if (initialMdn) {
      const cleanedMdn = initialMdn.startsWith("+1") ? initialMdn.substring(2) : initialMdn;
      formattedMdn = getFormatedContactNumber(cleanedMdn);
      setValue("mdn", formattedMdn);
    } else {
      setValue("mdn", "");
    }
    setValue("role", role);

    // Sync originalValuesRef with the actual form values being displayed
    originalValuesRef.current = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      mdn: initialMdn || ""
    };
    console.log("state is", state);
    if (isPendingUser) {
      if (state?.roleDetails) {
        setSelectedRole(state.roleDetails.name);
        setSelectedRoleId(state.roleDetails.id);
        setValue("role", state.roleDetails.name);
      } else if (state?.roleName) {
        setSelectedRole(state.roleName);
        setValue("role", state.roleName);
      }
      const hasSiteDetails = state?.siteDetails && Array.isArray(state.siteDetails) && state.siteDetails.length > 0;
      if (hasSiteDetails && !pendingUserInitialized) {
        const formattedSites = state.siteDetails.map(site => ({
          siteId: site.id,
          id: site.id,
          siteName: site.name,
          groups: [] 
        }));
        while (fields.length > 0) {
          remove(0);
        }
        formattedSites.forEach((site) => {
          append(site);
        });
        setValue("sites", formattedSites);
        setPendingUserInitialized(true);
      } else if (!hasSiteDetails && !pendingUserInitialized) {
        setPendingUserInitialized(true);
      }
    }
    // JS operation to change the checkbox group item width
    const radioGroups = document.querySelectorAll(
      "[data-testid='test-group-item']"
    );
    if (radioGroups) {
      radioGroups.forEach((rG) => (rG.style.width = "auto"));
    }
  }, [state, append, setValue, remove]);

  const fetchUserSites = async (skipLoadingState = false) => {
    if (!skipLoadingState) {
      setIsSitesLoading(true);
    }
    try {
      const rolePermissionsList = JSON.parse(
        sessionStorage.getItem("rolePermissionsList")
      );
      const selectedRole = JSON.parse(sessionStorage.getItem("selectedRole"));
      const currentUserEmail = activeSession?.userName;
      if (state?.Role || selectedRole) {
        const roleId = rolePermissionsList["id"];
        const payload = {
          accountname: activeSession.accountId,
          grant: {
            userid: state?.id || activeSession?.userId,
            roleid: state?.roleId,
          },
        };
        const response = await getUserSites(activeSession, payload);
        console.log("response is", response);
        let loginUserSites = [];
        if (selectedRole?.toLowerCase() === USER_ROLE.ADMIN) {
          const loginUserPayload = {
            ...payload,
            grant: { ...payload.grant, userid: activeSession.userId },
          };
          loginUserSites = siteTagList?.sites;
          setLoginUserSites(loginUserSites);
          if (loginUserSites.length === 0) {
            setNoAdminSites(true);
            setValue("sites", loginUserSites);
          } else {
            setNoAdminSites(false);
          }
        }
        if (response.length > 0) {
          const userSites = userAssociatedSites(response);
          const dropDownSites = response?.map((s) => s?.id);
          setDropDownSites(dropDownSites);
          setValue("sites", userSites);
          setSiteData(response);
          setUserSites(userSites);
        } else {
          const isAdmin =
            selectedRole?.toLowerCase() === USER_ROLE.ADMIN ||
            state?.customdata?.roles?.[0]?.name?.toLowerCase() === USER_ROLE.ADMIN;
          const userSites = isAdmin
            ? userAssociatedSites(siteTagList?.sites)
            : [];
          setValue("sites", isAdmin ? userSites : []);
          setNoAdminSites(isAdmin && userSites.length === 0);
          setSiteData(isAdmin ? loginUserSites : []);
          setUserSites(userSites);
        }
      }
    } catch (error) {
      console.log("error in fetching userSite", error);
      setValue("sites", []);
      setSiteData([]);
      setUserSites([]);
    } finally {
      // Only update loading state if we set it to true initially
      if (!skipLoadingState) {
        setIsSitesLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   dispatch(sitesModified(runtime));
  // }, []);

  const fetchNotificationGroups = async () => {
    try {
      const response = await axiosInstance.post(
        fetchNotificationGroupsEndPoint(),
        {
          accountName: activeSession.accountId,
        }
      );
      const notificationGroupResponse = response.data;
      sessionStorage.setItem(
        "userGroupsResponse",
        JSON.stringify(notificationGroupResponse)
      );
    } catch (error) {
      console.error("Error loading user groups table:", error);
    }
  };

  useEffect(() => {
    fetchNotificationGroups();
  }, []);

  useEffect(() => {
    // Skip re-fetching if data has already been initialized (prevents redundant fetches during/after save operations)
    if (isDataInitialized) {
      return;
    }

    const selectedRole = JSON.parse(sessionStorage.getItem("selectedRole"));
    setCurrentUserRole(selectedRole?.toLowerCase());
    if (isPendingUser) {
      if (siteTagList?.sites) {
        setLoginUserSites(siteTagList.sites);
      }
      getUserRole();
      setIsSitesLoading(false);
      setIsDataInitialized(true);
      return;
    }

    // For non-pending users
    if (!siteTagList?.sites || siteTagList.sites.length === 0) {
      dispatch(fetchCountryIdsRequest(() => {}));
      getUserRole();
      setIsSitesLoading(false);
      return;
    }

    if (!errorType) {
      fetchData();
      setIsDataInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteTagList?.sites, isDataInitialized]); 

  useEffect(() => {
    if (errorType) {
      setIsSitesLoading(false);
      setIsLoading(false);
    }
  }, [errorType])

  useEffect(() => {
    if (isPendingUser && siteTagList?.sites && fields) {
      const dropdownSiteIds = fields?.map(field => field.siteId) || [];
      setDropDownSites(dropdownSiteIds);
    }
  }, [isPendingUser, siteTagList?.sites, fields]);

  const fetchData = async () => {
    await getUserRole();
    
    const groups = getUserGroupsResponse();
    if (!groups) {
      await fetchNotificationGroups();
    }
    
    fetchUserSites();
  };

  const handlePhoneNumChange = (e) => {
    const input = e.target;
    const cursorPos = input.selectionStart;
    const oldValue = input.value;
    const digits = oldValue.replace(/\D/g, "").slice(0, 10);
    const formattedNum = getFormatedContactNumber(digits);
    const isValid = !isInvalidContactNumber(formattedNum);

    setInvalidPhoneNum(!isValid);
    setValue("mdn", formattedNum);
    setIsInputTouched(true);

    setTimeout(() => {
      if (!input) return;
      let newPos = cursorPos;
      const oldDashes = (oldValue.slice(0, cursorPos).match(/-/g) || []).length;
      const newDashes = (formattedNum.slice(0, cursorPos).match(/-/g) || []).length;
      newPos += newDashes - oldDashes;
      if (formattedNum[newPos] === "-") newPos++;
      input.setSelectionRange(newPos, newPos);
    }, 0);
  };

  const updateUserGroups = async () => {
    const groups = [...newGroups].filter(
      (groupId) => !existingGroups.includes(groupId)
    );
    try {
      // Ensure userid is always present
      const userId = state?.id || activeSession?.userId;
      if (!userId) {
        console.error("updateUserGroups: userid is missing");
        throw new Error("User ID is required for group updates");
      }

      const payload = {
        accountname: activeSession?.accountId,
        groupids: [...groups],
        userid: userId,
      };
      if (groups?.length > 0) {
        const response = await updateUserToGroups(activeSession, payload);
        // Check if response has an error status (400, 409, 500, etc.)
        if (response?.status && response.status >= 400) {
          return { status: response.status };
        }
        // Check if response indicates success (empty object or success status)
        if (Object.keys(response).length === 0 || response?.status === 200 || response?.status === 204) {
          return { status: 200 };
        } else {
          // API returned an unexpected response
          return { status: 500 };
        }
      }
      return { status: 200 };
    } catch (error) {
      console.log("error in updating groups in user details", error);
      // Return error status when exception occurs
      return { status: 500 };
    }
  };

  const updateUserSites = async () => {
    try {
      let revokeSites = [];
      let addSites = [];
      if (previousRoleId !== selectedRoleId) {
        if (selectedSites?.length > 0 && removeSites?.length <= 0) {
          revokeSites = dropDownSites?.filter(
            (site) => !selectedSites?.includes(site)
          );
          addSites = [...revokeSites, ...selectedSites];
        } else if (selectedSites?.length <= 0 && removeSites?.length > 0) {
          revokeSites = [...dropDownSites, ...removeSites];
          addSites = dropDownSites?.filter(
            (site) => !removeSites?.includes(site)
          );
        } else if (selectedSites?.length > 0 && removeSites?.length > 0) {
          revokeSites = [...dropDownSites, ...removeSites];
          addSites = [...dropDownSites]?.filter(
            (site) => !removeSites?.includes(site)
          );
        } else {
          revokeSites = dropDownSites;
          addSites = dropDownSites;
        }
      } else {
        revokeSites = removeSites?.length > 0 ? removeSites : [];
        addSites =
          removeSites?.length > 0
            ? [...selectedSites].filter((site) => !removeSites.includes(site))
            : selectedSites;
      }
      const sitesToBeDeleted = userSites.filter((obj) =>
        removeSites?.includes(obj?.siteId)
      );
      const roleId =
        previousRoleId !== selectedRoleId ? previousRoleId : selectedRoleId;
      try {
        if (revokeSites?.length > 0 || previousRoleId !== selectedRoleId) {
          const revokeResponse = await revokeRole(
            activeSession,
            state.id,
            roleId,
            revokeSites
          );
          if (revokeResponse === "") {
            setSelectedSites([]);
            setRemoveSites([]);
            sitesToBeDeleted?.forEach(async (site) => {
              const groups = site?.groups?.filter((g) => g?.associated);
              if (groups?.length > 0) {
                groups.forEach(async (group) => {
                  const deleteGroupResponse = await removeUsersToExistingGroup(
                    group?.id,
                    [currentUserId],
                    activeSession
                  );
                  console.log("deleteGroupResponse is^^^", deleteGroupResponse);
                });
              }
            });
          }
        }
        if (addSites?.length > 0 || previousRoleId !== selectedRoleId) {
          const response = await addRole(
            activeSession,
            state?.id,
            selectedRoleId,
            [...addSites],
            true
          );
          // Check if response indicates success (empty object means success)
          if (Object.keys(response).length === 0) {
            setSelectedSites([]);
            return { status: 204 };
          } else {
            // API returned an error response (e.g., 409 conflict)
            return { status: response?.status || 500 };
          }
        }
      } catch (error) {
        throw error;
      }
      return { status: 204 };
    } catch (error) {
      console.log("error in updating groups in user details", error);
      // Return error status when exception occurs
      return { status: 500 };
    }
  };

  const resetPhoneToOriginal = () => {
    const formatted = getFormatedContactNumber(originalValuesRef.current.mdn || "");
    if (setValue) {
      setValue("mdn", formatted || "");
      setValue('firstname', originalValuesRef.current.firstname);
      setValue('lastname', originalValuesRef.current.lastname);
      setValue('email', originalValuesRef.current.email);
    }
    setInvalidPhoneNum(false);
    
  };

  const handleOTPClose = () => {
    resetPhoneToOriginal();
    setShowOTPModal(false);
    setPendingMDNData(null);
    setIsSaving(false);
    setisEditable(false);
  };


  const onValidHandler = async (data, name = "") => {
    if (invalidPhoneNum) {
      return;
    }
    setShowOTPModal(false);
    setPendingMDNData(null);
    setIsSaving(true);
    const cleanMDN = (mdn) => {
      if (mdn) {
        return mdn.replace(NON_NUMERIC_REGEX, "");
      }
      return "";
    };

    delete data?.sites;

    const originalFirstname = originalValuesRef.current.firstname;
    const originalLastname = originalValuesRef.current.lastname;
    const originalEmail = originalValuesRef.current.email;
    const originalMDN = originalValuesRef.current.mdn;

    // Site managers/viewers can edit their own profile; admins can edit other users (not their own)
    const canEditUserDetails = (isCurrentUserNonAdmin && isEditingOwnProfile) || (!isCurrentUserNonAdmin && !isEditingOwnProfile);
    const isUserDataModified = canEditUserDetails && (
      (originalFirstname !== data.firstname) ||
      (originalLastname !== data.lastname) ||
      (originalEmail !== data.email)
    );

    const isLoggedInUser = (state?.id && state.id === activeSession?.userId) || !state?.id;
    const isPhoneFieldDisabled = getPhoneFieldState().disabled;
    const mdnWasModified = (!isPhoneFieldDisabled && isLoggedInUser) ? isMDNModified(data.mdn, getFormatedContactNumber(originalMDN)) : false;

    let cleanedMDN = "";
    if (data.mdn) {
      cleanedMDN = cleanMDN(data.mdn);
      if (cleanedMDN.length === 10) {
        cleanedMDN = "+1" + cleanedMDN;
      }
    }

    const payload = {
      accountName: activeSession?.accountId,
      id: state?.id || activeSession?.userId,
      user: {
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
      },
    };

    if (!isPendingUser) {
      let firstEndpointSuccess = false;
      let secondEndpointCalled = false;

      if (isUserDataModified) {
        try {
          const response = await axiosInstance.patch(
            updateNotificationUsersEndPoint(),
            { ...payload }
          );

          if (response?.status === 200) {
            firstEndpointSuccess = true;
            const isLoggedInUser = state?.id && state.id === activeSession?.userId;
            if (isLoggedInUser) {
              dispatch(setUserActiveSession({
                activeSession: {
                  ...activeSession,
                  firstName: data.firstname,
                  lastName: data.lastname,
                  userName: data.email
                }
              }));
            }
            originalValuesRef.current.firstname = data.firstname;
            originalValuesRef.current.lastname = data.lastname;
            originalValuesRef.current.email = data.email;

            if (!mdnWasModified) {
              const successItems = [];
              const failureItems = [];

              // User details were modified - track specific fields
              if (originalFirstname !== data.firstname) {
                successItems.push(USER_DETAILS_FIELD_FIRST_NAME);
              }
              if (originalLastname !== data.lastname) {
                successItems.push(USER_DETAILS_FIELD_LAST_NAME);
              }

              try {
                const areSitesModified = removeSites.length > 0 || selectedSites.length > 0;
                const areGroupsModified = newGroups.length > 0;
                const isRoleModified = previousRoleId !== selectedRoleId;

                // Only call update functions if something was actually modified
                if (areSitesModified || areGroupsModified || isRoleModified) {
                  const [updateUserGroupsResponse, updateAddSites] = await Promise.allSettled([updateUserGroups(), updateUserSites()]);
                  setBannerData(data.firstname + " " + data.lastname);

                  const groupsSuccess = updateUserGroupsResponse.status === PROMISE_STATUS_FULFILLED && updateUserGroupsResponse.value?.status === 200;
                  const sitesSuccess = updateAddSites.status === PROMISE_STATUS_FULFILLED && updateAddSites.value?.status === 204;

                  if (isRoleModified) {
                    if (sitesSuccess) {
                      successItems.push(USER_DETAILS_FIELD_ROLE);
                      setPreviousRoleId(selectedRoleId);
                    } else {
                      failureItems.push(USER_DETAILS_FIELD_ROLE);
                    }
                  }

                  if (areSitesModified) {
                    if (sitesSuccess) {
                      successItems.push(USER_DETAILS_FIELD_SITES);
                    } else {
                      failureItems.push(USER_DETAILS_FIELD_SITES);
                    }
                  }

                  if (areGroupsModified) {
                    if (groupsSuccess) {
                      successItems.push(USER_DETAILS_FIELD_GROUPS);
                    } else {
                      failureItems.push(USER_DETAILS_FIELD_GROUPS);
                    }
                  }
                }

                dispatch(showAggregatedNotification(
                  successItems.length > 0 ? notificationTypes[23] : notificationTypes[88],
                  NOTIFICATION_PRIORITY_SUCCESS,
                  successItems,
                  USER_DETAILS_UPDATE_SUCCESS_SUFFIX,
                  USER_DETAILS_UPDATE_FAILED_PREFIX,
                  false,
                  true,
                  failureItems
                ));

                setisEditable(false);
                setIsSaving(false);
                setIsInputTouched(false);

                // Only fetch data and update state if sites/groups/roles were modified
                if (areSitesModified || areGroupsModified || isRoleModified) {
                  setSelectedSites([]);
                  setRemoveSites([]);
                  setNewGroups([]);

                  // First refresh notification groups
                  await fetchNotificationGroups();

                  if (!isPendingUser) {
                    await fetchUserSites(true);
                  }

                  setRefreshUsersTable(true);
                }
              } catch (error) {
                const notificationInfo = {
                  type: notificationTypes[88],
                  priority: NOTIFICATION_PRIORITY_CRITICAL,
                  data: {
                    subTitle: USER_DETAILS_UPDATE_ERROR + GROUPS_SITES_UPDATE_FAILED,
                  },
                  showNotification: true,
                };
                dispatch(showNotificationBanner(notificationInfo));
                setisEditable(false);
                setIsSaving(false);
              }
              return;
            }
          }
        } catch (error) {
          setTimeout(() => {
            setValue('firstname', originalFirstname);
            setValue('lastname', originalLastname);
            setValue('email', originalEmail);
          }, 0);
          
          setIsInputTouched(false);
          setisEditable(false);
          
          const notificationInfo = {
            type: NOTIFICATION_TYPE_USER_DETAILS_NOT_UPDATED,
            priority: NOTIFICATION_PRIORITY_CRITICAL,
            data: {
              subTitle: USER_UPDATE_ERROR,
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          setIsSaving(false);
        }
      }

      if (mdnWasModified) {
        secondEndpointCalled = true;
        try {
          const mdnPayload = { mdn: cleanedMDN };

          const mdnResponse = await axiosInstance.post(
            updateMdnNotificationUsersEndPoint(),
            mdnPayload
          );

          if (mdnResponse.status === 200 || mdnResponse.status === 204) {
            // If name was also modified, show notification for name changes
            if (firstEndpointSuccess && isUserDataModified) {
              const successItems = [];
              if (originalFirstname !== data.firstname) {
                successItems.push(USER_DETAILS_FIELD_FIRST_NAME);
              }
              if (originalLastname !== data.lastname) {
                successItems.push(USER_DETAILS_FIELD_LAST_NAME);
              }

              if (successItems.length > 0) {
                dispatch(showAggregatedNotification(
                  notificationTypes[23],
                  NOTIFICATION_PRIORITY_SUCCESS,
                  successItems,
                  USER_DETAILS_UPDATE_SUCCESS_SUFFIX,
                  USER_DETAILS_UPDATE_FAILED_PREFIX,
                  false,
                  true,
                  []
                ));
              }
            }

            // Show OTP modal - use updated values from data
            setValue('firstname', data.firstname);
            setValue('lastname', data.lastname);
            setValue('email', data.email);

            setPendingMDNData({
              firstname: data.firstname,
              lastname: data.lastname,
              mdn: cleanedMDN,
              email: data.email,
            });
            setIsSaving(false);
            resetModal(MODAL_NAME_OTP);
            setShowOTPModal(true);
            return;
          }
        } catch (mdnError) {
          const notificationInfo = {
            type: NOTIFICATION_TYPE_RESEND_INVITE,
            priority: NOTIFICATION_PRIORITY_CRITICAL,
            data: {
              subTitle: FAILED_TO_SEND_OTP,
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          setIsSaving(false);
        }
      }

      if (!isUserDataModified && !mdnWasModified) {
        // Check if sites, groups, or role were modified
        const areSitesModified = removeSites.length > 0 || selectedSites.length > 0;
        const areGroupsModified = newGroups.length > 0;
        const isRoleModified = previousRoleId !== selectedRoleId;

        if (areSitesModified || areGroupsModified || isRoleModified) {
          const successItems = [];
          const failureItems = [];

          try {
            const [updateUserGroupsResponse, updateAddSites] = await Promise.allSettled([updateUserGroups(), updateUserSites()]);
            const groupsSuccess = updateUserGroupsResponse.status === PROMISE_STATUS_FULFILLED && updateUserGroupsResponse.value?.status === 200;
            const sitesSuccess = updateAddSites.status === PROMISE_STATUS_FULFILLED && updateAddSites.value?.status === 204;

            if (isRoleModified) {
              if (sitesSuccess) {
                successItems.push(USER_DETAILS_FIELD_ROLE);
                setPreviousRoleId(selectedRoleId);
              } else {
                failureItems.push(USER_DETAILS_FIELD_ROLE);
              }
            }

            if (areSitesModified) {
              if (sitesSuccess) {
                successItems.push(USER_DETAILS_FIELD_SITES);
              } else {
                failureItems.push(USER_DETAILS_FIELD_SITES);
              }
            }

            if (areGroupsModified) {
              if (groupsSuccess) {
                successItems.push(USER_DETAILS_FIELD_GROUPS);
              } else {
                failureItems.push(USER_DETAILS_FIELD_GROUPS);
              }
            }

            dispatch(showAggregatedNotification(
              successItems.length > 0 ? notificationTypes[23] : notificationTypes[88],
              NOTIFICATION_PRIORITY_SUCCESS,
              successItems,
              USER_DETAILS_UPDATE_SUCCESS_SUFFIX,
              USER_DETAILS_UPDATE_FAILED_PREFIX,
              false,
              true,
              failureItems
            ));

            if (successItems.length > 0) {
              setSelectedSites([]);
              setRemoveSites([]);
              setNewGroups([]);

              // First refresh notification groups
              await fetchNotificationGroups();

              if (!isPendingUser) {
                await fetchUserSites(true);
              }

              setRefreshUsersTable(true);
              setIsInputTouched(false);
            }
          } catch (error) {
            console.error('Failed to update groups/sites:', error);
            const notificationInfo = {
              type: notificationTypes[88],
              priority: NOTIFICATION_PRIORITY_CRITICAL,
              data: {
                subTitle: GROUPS_SITES_UPDATE_FAILED,
              },
              showNotification: true,
            };
            dispatch(showNotificationBanner(notificationInfo));
          }
        }

        setIsSaving(false);
        setisEditable(false);
      }
    } else {
      try {
        const userId = state?.id;
        let userData = getUserDataFromSubmittedForm(data);
        userData = { ...userData, oldinvitationid: userId };
        const inviteResponse = await reinviteUser(userData, activeSession, null, () => {});

        if (inviteResponse?.wasemailsent) {
          const notificationInfo = {
            type: NOTIFICATION_TYPE_UPDATED_INVITE_SENT,
            priority: NOTIFICATION_PRIORITY_SUCCESS,
            data: {
              subTitle: INVITE_RESENT_SUCCESS
                .replace("{firstname}", userData.firstname)
                .replace("{lastname}", userData.lastname),
            },
            showNotification: true,
          };
          dispatch(showNotificationBanner(notificationInfo));
          setisEditable(false);
          setIsSaving(false);
          navigate(ROUTES.USERGROUPS, {
            state: {
              tabName: TAB_NAMES.PENDING_INVITES,
              fromPage: "UserDetails",
            }
          });
        } else {
          throw new Error("Failed to send updated invitation.");
        }
      } catch (error) {
        const notificationInfo = {
          type: NOTIFICATION_TYPE_RESEND_INVITE,
          priority: NOTIFICATION_PRIORITY_CRITICAL,
          data: {
            subTitle: FAILED_TO_RESEND_INVITE,
          },
          showNotification: true,
        };
        dispatch(showNotificationBanner(notificationInfo));
      } finally {
        setIsSaving(false);
        setisEditable(false);
      }
    }
  };

  const handleVerifyOTP = async (otpValue) => {
    setOTPLoading(true);
    const successItems = [];
    const failureItems = [];

    // Track what user details were modified (from the first endpoint call)
    if (pendingMDNData) {
      if (originalValuesRef.current.firstname !== pendingMDNData.firstname) {
        successItems.push(USER_DETAILS_FIELD_FIRST_NAME);
      }
      if (originalValuesRef.current.lastname !== pendingMDNData.lastname) {
        successItems.push(USER_DETAILS_FIELD_LAST_NAME);
      }
    }

    try {
      const response = await axiosInstance.post(updateOtpNotificationUsersEndPoint(), {
        otp: otpValue,
      });

      if (response.status === 200 || response.status === 204) {
        // MDN update successful
        successItems.push(USER_DETAILS_FIELD_PHONE_NUMBER);
        if (pendingMDNData && pendingMDNData.mdn) {
          originalValuesRef.current.mdn = pendingMDNData.mdn;
          // Only update session after successful OTP verification confirmed by backend
          const isLoggedInUser = (state?.id && state.id === activeSession?.userId) || !state?.id;
          const isVerified = response.data?.verified !== false;
          if (isLoggedInUser && isVerified) {
            dispatch(setUserActiveSession({
              activeSession: {
                ...activeSession,
                mdn: pendingMDNData.mdn
              }
            }));
          }
        }

        // Update originalValues if user details were modified (but don't add to successItems - already tracked above)
        const isUserDataModified = pendingMDNData && (
          originalValuesRef.current.firstname !== pendingMDNData.firstname ||
          originalValuesRef.current.lastname !== pendingMDNData.lastname ||
          originalValuesRef.current.email !== pendingMDNData.email
        );

        if (isUserDataModified) {
          originalValuesRef.current.firstname = pendingMDNData.firstname;
          originalValuesRef.current.lastname = pendingMDNData.lastname;
          originalValuesRef.current.email = pendingMDNData.email;
        }

        // Update groups and sites only if they were modified
        const areSitesModified = removeSites.length > 0 || selectedSites.length > 0;
        const areGroupsModified = newGroups.length > 0;
        const isRoleModified = previousRoleId !== selectedRoleId;

        if (areSitesModified || areGroupsModified || isRoleModified) {
          try {
            const [updateUserGroupsResponse, updateAddSites] = await Promise.allSettled([updateUserGroups(), updateUserSites()]);
            setBannerData(pendingMDNData.firstname + " " + pendingMDNData.lastname);

            const groupsSuccess = updateUserGroupsResponse.status === PROMISE_STATUS_FULFILLED && updateUserGroupsResponse.value?.status === 200;
            const sitesSuccess = updateAddSites.status === PROMISE_STATUS_FULFILLED && updateAddSites.value?.status === 204;

            if (isRoleModified) {
              if (sitesSuccess) {
                successItems.push(USER_DETAILS_FIELD_ROLE);
                setPreviousRoleId(selectedRoleId);
              } else {
                failureItems.push(USER_DETAILS_FIELD_ROLE);
              }
            }

            if (areSitesModified) {
              if (sitesSuccess) {
                successItems.push(USER_DETAILS_FIELD_SITES);
              } else {
                failureItems.push(USER_DETAILS_FIELD_SITES);
              }
            }

            if (areGroupsModified) {
              if (groupsSuccess) {
                successItems.push(USER_DETAILS_FIELD_GROUPS);
              } else {
                failureItems.push(USER_DETAILS_FIELD_GROUPS);
              }
            }

            // Refresh data if any sites/groups/role updates succeeded
            if (groupsSuccess || sitesSuccess) {
              setSelectedSites([]);
              setRemoveSites([]);
              setNewGroups([]);

              // First refresh notification groups
              await fetchNotificationGroups();

              if (!isPendingUser) {
                await fetchUserSites(true);
              }

              setRefreshUsersTable(true);
              setIsInputTouched(false);
            }
          } catch (error) {
            // Add failure messages based on what was actually modified and failed
            if (isRoleModified) {
              failureItems.push(USER_DETAILS_FIELD_ROLE);
            }
            if (areSitesModified) {
              failureItems.push(USER_DETAILS_FIELD_SITES);
            }
            if (areGroupsModified) {
              failureItems.push(USER_DETAILS_FIELD_GROUPS);
            }
          }
        }

        // Display combined success and failure messages
        dispatch(showAggregatedNotification(
          successItems.length > 0 ? notificationTypes[23] : notificationTypes[88],
          NOTIFICATION_PRIORITY_SUCCESS,
          successItems,
          USER_DETAILS_UPDATE_SUCCESS_SUFFIX,
          USER_DETAILS_UPDATE_FAILED_PREFIX,
          false,
          true,
          failureItems
        ));

        setShowOTPModal(false);
        setPendingMDNData(null);
        setisEditable(false);
        setIsSaving(false);

        // Delay navigation to allow notification to render
        setTimeout(() => {
          navigate(ROUTES.USERGROUPS, {
            state: {
              tabName: TAB_NAMES.USERS,
              fromPage: "UserDetails",
            }
          });
        }, NAVIGATION_DELAY);
      }
    } catch (error) {
      const formatted = getFormatedContactNumber(originalValuesRef.current.mdn || "");
      setValue('mdn', formatted || "");
      setInvalidPhoneNum(false);
      
      const notificationInfo = {
        type: NOTIFICATION_TYPE_USER_DETAILS_NOT_UPDATED,
        priority: NOTIFICATION_PRIORITY_CRITICAL,
        data: {
          subTitle: INVALID_OTP_ERROR,
        },
        showNotification: true,
      };
      dispatch(showNotificationBanner(notificationInfo));
      setOTPLoading(false);
      throw error; 
    } finally {
      setOTPLoading(false);
    }
  };

  const onSubmitHandler = async (e) => {
    if (!isEditable) {
      setisEditable(true);
    } else {
      const inputs = document.querySelectorAll("input");
      inputs.forEach((input) => {
        input.blur();
      });
      await handleSubmit(onValidHandler)(e);
    }
  };

  const formValues = watch();

  // Memoize userName to avoid recalculating on every render
  const userName = useMemo(() =>
    `${formValues?.firstname || ''} ${formValues?.lastname || ''}`.trim(),
    [formValues?.firstname, formValues?.lastname]
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "role") {
      setSelectedRole(e.target.value);
      const selectedRoleItem = rolesList.find((role) => role.name === value);
      if (selectedRoleItem) {
        setSelectedRoleId(selectedRoleItem.id);
      }
    }
    setValue(name, value);
    setIsInputTouched(true);
  };

  useEffect(() => {
    let timer = "";
    window?.scrollTo({ top: 0, behaviour: "smooth" });
    if (showNotificationPopup?.show) {
      ref?.current?.scrollIntoView({ behavior: "smooth" });
      timer = setTimeout(() => {
        setShowNotificationPopup(null);
      }, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [showNotificationPopup?.show]);

  const fieldsLength = fields?.length;
  const siteIds = siteData?.map((site) => site.id);
  const availableOptions = [...(loginUserSites || []), ...(trashedSites || [])]
    .filter(
      (userSite) =>
        ![...siteIds, ...dropDownSites].some((siteId) => siteId === userSite.id)
    )
    .sort((a, b) =>
      (a?.name || a?.siteName).localeCompare(b?.name || b?.siteName)
    );

  const deleteSites = (item) => {
    if (isRestricted()) return false;
    if (fields?.length <= 1 && getIsNotAdmin(selectedRole)) return false;

    // Show confirmation modal before deleting
    resetModal(MODAL_NAME_REMOVE_SITE);
    setSiteToRemove({
      siteId: item?.siteId,
      siteName: item?.siteName || DEFAULT_SITE_LABEL,
      userName: userName || 'this user',
      item: item
    });
    setShowRemoveSiteModal(true);
  };

  const confirmRemoveSite = () => {
    if (!siteToRemove) return;

    const { item } = siteToRemove;
    const index = fields.findIndex((field) => field?.siteId === item?.siteId);
    const site = fields.find((field) => field?.siteId === item?.siteId);
    const loginUserSiteIds = loginUserSites.map((item) => item?.id);
    const isLoginUserSite = loginUserSiteIds.includes(site?.siteId);
    const siteGroups = item?.groups?.map((group) => group?.id);
    const groups = newGroups?.filter(
      (groupId) => !siteGroups?.includes(groupId)
    );

    if (isLoginUserSite) {
      setDropDownSites((prevSites) =>
        prevSites.filter((siteId) => siteId !== site?.siteId)
      );
    }
    setRemoveSites((prevRemoveSites) => [...prevRemoveSites, site?.siteId]);
    setNewGroups(groups);
    remove(index);
    setIsInputTouched(true);

    setShowRemoveSiteModal(false);
    setSiteToRemove(null);
  };

  const handleCloseRemoveSiteModal = () => {
    setShowRemoveSiteModal(false);
    setSiteToRemove(null);
  };

  const isRoleReadOnly = getIsRoleReadOnly(noAdminSites, selectedRole, { isCurrentUserNonAdmin, isEditingOwnProfile });

  const isRestricted = () =>
    !isEditable || !hasPermission(PERMISSION_ROLE_MANAGEMENT, "Edit");

  const isSiteDeleteDisabled = () =>
    isRestricted() || (fields?.length <= 1 && getIsNotAdmin(selectedRole));

  const renderTooltip = () => {
    return fields?.length <= 1 && getIsNotAdmin(selectedRole) ? (
      <Tooltip
        title={
          <div className="tooltip-delete-content">
            <Body viewport="desktop" size="medium">
              {DELETE_SITE_NO_PERMISSION_TOOLTIP}
            </Body>
          </div>
        }
        arrow
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: "white",
              border: "1px solid black",
              "& .MuiTooltip-arrow": {
                backgroundColor: "white",
              },
            },
          },
        }}
      >
        <span className="tooltip-delete-icon">
          <Icon ariaLabel="" name="trash" size="medium" color="#6F7171" />
        </span>
      </Tooltip>
    ) : (
      <Tooltip
        title={isRestricted() ? DELETE_SITE_NO_AUTH_TOOLTIP : DELETE_SITE_TOOLTIP}
        arrow
        placement="top"
      >
        <span className="tooltip-delete-icon">
          <Icon
            name="trash"
            size="medium"
            color="#000000"
          />
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      <CancelModal
        key={`cancel-modal-${modalKeys[MODAL_NAME_CANCEL]}`}
        opened={showCancelModal}
        onConfirm={confirmCancel}
        onClose={denyCancel}
      />
      <RemoveGroupModal
        key={`remove-group-modal-${modalKeys[MODAL_NAME_REMOVE_GROUP]}`}
        opened={showRemoveGroupModal}
        groupToRemove={groupToRemove}
        onConfirm={confirmRemoveGroup}
        onClose={handleCloseRemoveGroupModal}
      />
      <RemoveSiteModal
        key={`remove-site-modal-${modalKeys[MODAL_NAME_REMOVE_SITE]}`}
        opened={showRemoveSiteModal}
        siteToRemove={siteToRemove}
        onConfirm={confirmRemoveSite}
        onClose={handleCloseRemoveSiteModal}
      />
      <AddGroupModal
        key={`add-group-modal-${modalKeys[MODAL_NAME_ADD_GROUP]}`}
        opened={showModal}
        selectedSite={selectedSite}
        selectedGroups={selectedGroups}
        onGroupSelection={handleGroupSelection}
        onAddSelectedGroups={handleAddSelectedGroups}
        onClose={handleCloseModal}
        userName={userName}
      />
      <OTPVerificationModal
        key={`otp-modal-${modalKeys[MODAL_NAME_OTP]}`}
        opened={showOTPModal}
        onClose={handleOTPClose}
        onVerify={handleVerifyOTP}
        isLoading={otpLoading}
        userEmail={pendingMDNData?.email || state?.email || ""}
        pendingMDNData={pendingMDNData ? {
          ...pendingMDNData,
          userId: state?.id || activeSession?.userId
        } : null}
      />
      <ResendInviteModal
        opened={showResendModal}
        onOpenedChange={setShowResendModal}
        selectedUser={{ Email: state?.Email || state?.inviteeemail }}
        confirmResend={confirmResendInvite}
      />
      <UsersOnBillingAccountModal
        key={`billing-modal-${modalKeys[MODAL_NAME_BILLING]}`}
        opened={isModalVisible}
        accountId={selectedAccountId}
        users={users.filter((user) => user?.billingaccountid === selectedAccountId)}
        onClose={() => setIsModalVisible(false)}
      />

      <Loader active={isSaving} fullscreen />
      <div id="test" className="d-flex section-margin-sm">
        <Breadcrumbs surface="light">
          <BreadcrumbItem>
            <Link
              data-testid="userDetails_settingsLink"
              to="/settings"
              className="breadcrums-item_link"
            >
              Settings
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/usergroups"
              state={{ tabName: state?.tabName || "Users" }}
              className="breadcrums-item_link"
              data-testid="userDetails_userGroupsLink"
            >
              {state?.tabName || "Users"}
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>User Details</BreadcrumbItem>
        </Breadcrumbs>
      </div>
      <br />
      <div className="d-flex justify-content-between user-details-header">
        <div>
          <Title size="large" bold={false}>
            User Details
          </Title>
          {isPendingUser && (
            <div className="invited-badge">
              Invited
            </div>
          )}
        </div>
        <div className="user-details-button-group">
          {isPendingUser && !isEditable && (
            <Button
              size="large"
              use="secondary"
              type="button"
              data-testid="userdetails_resendInviteButton"
              onClick={handleResendInvite}
              disabled={showResendModal}
              className="user-details-btn"
            >
              {USER_DETAILS_BUTTON_RESEND_INVITE}
            </Button>
          )}
          {/* Hide Edit button only when non-admin views another user's profile (not their own) */}
          {!(state?.id && !isEditingOwnProfile && isCurrentUserNonAdmin) && (
            <Button
              size="large"
              use="primary"
              type={!isEditable ? "button" : "submit"}
              data-testid="userdetails_editOrSaveDetailsButton"
              onClick={(e) => {
                if (!isEditable) {
                  setisEditable(true);
                } else if (isEditable) {
                  onSubmitHandler(e);
                }
                toggleEditMode();
              }}
              disabled={isSaving || (isEditable && !isInputTouched) || invalidPhoneNum}
              className="user-details-btn"
            >
              {!isEditable && isCurrentUserNonAdmin ? (
                <Tooltip
                  title={USER_DETAILS_TOOLTIP_EDIT_OWN_PROFILE}
                  arrow
                  placement="top"
                  classes={{ tooltip: 'user-details-edit-button-tooltip' }}
                >
                  <span className="tooltip-trigger-span">{USER_DETAILS_BUTTON_EDIT}</span>
                </Tooltip>
              ) : (
                !isEditable ? USER_DETAILS_BUTTON_EDIT : USER_DETAILS_BUTTON_SAVE
              )}
            </Button>
          )}
          {isEditable && (
            <Button
              size="large"
              use="secondary"
              type="button"
              data-testid="userdetails_cancelButton"
              onClick={handleCancel}
              className="user-details-btn"
            >
              {MODAL_CANCEL_BUTTON}
            </Button>
          )}
        </div>
      </div>
      <div className="row w-80 d-flex flex-column gap-4">
        <div className="section w-50 section-margin-bottom">
          <div className="row">
            <Title size="small" bold={true}>
              Name
            </Title>
          </div>
          <div
            className={`d-flex justify-content-between gap-4 mt-2 ${
              !isEditable ? "pe-none" : ""
            }`}
          >
            <Input
              type="text"
              label="First name"
              error={false}
              errorText="Enter a valid first name."
              readOnly={getNameFieldState().readOnly}
              disabled={getNameFieldState().disabled}
              value={formValues?.firstname || formValues?.inviteefirstname || ""}
              name="firstname"
              className={`form-input-field ${!isEditable ? "pe-none" : ""}`}
              {...register("firstname", { required: true })}
              onChange={handleInputChange}
            />
            <Input
              type="text"
              label="Last name"
              readOnly={getNameFieldState().readOnly}
              disabled={getNameFieldState().disabled}
              required={true}
              error={false}
              errorText="Enter a valid last name."
              value={formValues?.lastname || formValues?.inviteelastname || ""}
              name="lastname"
              className={`form-input-field ${!isEditable ? "pe-none" : ""}`}
              {...register("lastname", { required: true })}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="section w-50 section-margin-bottom">
          <div className="row">
            <Title size="small" bold={true}>
              Contact Information
            </Title>
          </div>
          <div
            className={`d-flex justify-content-between gap-4 mt-2 ${
              !isEditable ? "pe-none" : ""
            }`}
          >
            <Input
              type="text"
              label="Phone number"
              readOnly={getPhoneFieldState().readOnly}
              required={true}
              disabled={getPhoneFieldState().disabled}
              error={invalidPhoneNum}
              name="mdn"
              errorText="Enter a valid phone number."
              className={`form-input-field ${!isEditable ? "pe-none" : ""}`}
              value={getDisplayPhoneNumber(formValues?.mdn || formValues?.inviteemdn || "")}
              {...register("mdn", { required: true })}
              onChange={handlePhoneNumChange}
            />
            <Input
              type="text"
              label="Email"
              readOnly={true}
              disabled={isEditable}
              required={true}
              error={false}
              errorText="Enter a valid email."
              value={formValues?.email || formValues?.inviteeemail || ""}
              name="email"
              className={`form-input-field ${!isEditable ? "pe-none" : ""}`}
              {...register("email", { required: true })}
            />
          </div>
        </div>
        <div className="section w-50 section-margin-bottom">
          <div className="row">
            <Title size="small" bold={true}>
              Platform Permissions
            </Title>
          </div>
          <div
            className={`d-flex justify-content-between gap-4 mt-2 ${
              !isEditable ? "pe-none" : ""
            }`}
          >
            {isRestricted() ? (
              <div className="billing-account-container">
                <p className="billing-account-label">Billing Account</p>
                {isLoading ? (
                  <div className="billing-account-spinner">
                    <Spin />
                  </div>
                ) : (
                  billingAccounts?.map((ba, index) => (
                    <div key={index} className="billing-account-row">
                      <div className="billing-account-width">
                        <Tooltip
                          title={BILLING_ACCOUNT_NO_PERMISSION_TOOLTIP}
                          arrow
                          placement="top"
                        >
                          <span>
                            <Checkbox
                              selected={checkedBillingIds.includes(ba)}
                              disabled={true}
                            />
                          </span>
                        </Tooltip>
                      </div>
                      <div className="responsive-table-wrapper">
                        <ListGroup
                          topLine={false}
                          bottomLine={true}
                          surface="light"
                          viewport="mobile"
                        >
                          <ListGroupItem key={index} actionElement="none">
                            <ListGroupItemTitle bold={false}>
                              {ba}
                            </ListGroupItemTitle>
                            <ListGroupItemSubtitle>
                              <a
                                data-testid="userdetails_viewUsersButton"
                                className="billing-account-link"
                                onClick={() => handleViewUsersClick(ba)}
                              >
                                {USER_DETAILS_LINK_VIEW_USERS_ON_ACCOUNT}
                              </a>
                            </ListGroupItemSubtitle>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                    </div>
                  ))
                )}
              </div>
            ) : (
              <div className="billing-account-container">
                <p className="billing-account-label-readonly">Billing Account</p>
                {billingAccounts?.map((ba, index) => (
                  <div className="billing-account-row">
                    <div className="billing-account-width">
                      <Tooltip
                        title={BILLING_ACCOUNT_NO_PERMISSION_TOOLTIP}
                        arrow
                        placement="top"
                      >
                        <span>
                          <Checkbox
                            selected={checkedBillingIds.includes(ba)}
                            disabled={true}
                          />
                        </span>
                      </Tooltip>
                    </div>
                    <div className="responsive-table-wrapper">
                      <ListGroup
                        topLine={false}
                        bottomLine={true}
                        surface="light"
                        viewport="mobile"
                      >
                        <ListGroupItem key={index} actionElement="none">
                          <ListGroupItemTitle bold={false}>
                            {ba}
                          </ListGroupItemTitle>
                          <ListGroupItemSubtitle>
                            <a
                              data-testid="userdetails_viewUsersButton"
                              className="billing-account-link"
                              onClick={() => handleViewUsersClick(ba)}
                            >
                              {USER_DETAILS_LINK_VIEW_USERS_ON_ACCOUNT}
                            </a>
                          </ListGroupItemSubtitle>
                        </ListGroupItem>
                      </ListGroup>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {isRestricted() || isRoleReadOnly ? (
              <div className="billing-account-position">
                <Input
                  id="role"
                  type="text"
                  label="Role"
                  width="330px"
                  readOnly={true}
                  disabled={isEditable}
                  required={true}
                  error={false}
                  name="role"
                  value={selectedRole}
                  errorText="Enter a valid role."
                  className={`w-100 ${!isEditable ? "pe-none" : ""}`}
                  {...register("role")}
                />
              </div>
            ) : (
              <div className={`billing-account-full-width${isRoleReadOnly ? " role-disabled" : ""}`}>
                <DropdownSelect
                  label="Role"
                  width="330px"
                  errorText="Select a Role"
                  error={false}
                  disabled={isRoleReadOnly}
                  readOnly={isRoleReadOnly}
                  name="role"
                  value={selectedRole}
                  {...register("role")}
                  onChange={handleInputChange}
                >
                  {Array.isArray(rolesList) &&
                    rolesList
                      .filter(
                        (item) =>
                          item?.name.toLowerCase() !== USER_ROLE.ADMIN ||
                          selectedRole?.toLowerCase() === USER_ROLE.ADMIN
                      )
                      .map((item) => (
                        <option key={item?.id} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                </DropdownSelect>
              </div>
            )}
            <div className="w-50"></div>
          </div>
        </div>
        <div className="section d-flex flex-column section-margin-bottom">
          <div className="row mb-3">
            <Title size="small" bold={true}>
              {SITES_AND_GROUPS_SECTION_TITLE_PREFIX}{formValues?.firstname || ""} {formValues?.lastname || ""} {SITES_AND_GROUPS_SECTION_TITLE_SUFFIX}
            </Title>
          </div>
          {isSitesLoading ? (
            <div className="loading-center">
              <Loader active={true} />
            </div>
          ) : (
            <>
            {fields?.length > 0 &&
            fields?.map((item, index) => (
              <div key={item.id} className="site-item">
                <div className={`site-item-row ${!isEditable ? "pe-none" : ""}`}>
                  <div className="site-input-container">
                    <Input
                      type="text"
                      label="Site"
                      width="100%"
                      readOnly={!isEditable}
                      required={true}
                      error={false}
                      name="site"
                      value={item?.siteName || item?.site}
                      errorText="Enter a valid name."
                      className={`site-input-field ${!isEditable ? "pe-none" : ""}`}
                      {...register(`sites[${index}].name`, { required: true })}
                    />
                    {isEditable && !(isEditingOwnProfile && !isCurrentUserNonAdmin) && (
                      <div
                        className={`mt-3 d-flex align-items-end position-relative site-delete-icon ${isSiteDeleteDisabled() ? 'disabled' : ''}`}
                        data-testid="userdetails_atLeastOneSite-item"
                        onClick={() => deleteSites(item)}
                      >
                        {!noAdminSites ? renderTooltip() : null}
                      </div>
                    )}
                  </div>
                  {renderSitesContent(isEditable, item)}
                </div>
                {fieldsLength > 1 ? (
                  <hr
                    className={
                      index === fieldsLength - 1
                        ? "site-divider site-divider-hidden"
                        : "site-divider"
                    }
                  />
                ) : null}
              </div>
            ))}
        </>
          )}
          {isEditable && (
            <>
              <div className="site-actions-container">
                {showSiteInput && (
                  <div className="site-dropdown">
                    <DropdownSelect
                      label="Site"
                      width="100%"
                      errorText="Select a site"
                      error={false}
                      disabled={false}
                      readOnly={false}
                      name="site"
                      value={selectedSite}
                      onChange={handleSelectSite}
                    >
                      <option value="">Select a Site</option>
                      {availableOptions?.length > 0 &&
                      Array.isArray(availableOptions) ? (
                        availableOptions?.map((item) => (
                          <option
                            value={item?.name}
                            key={item?.id}
                            data-siteId={item?.siteId}
                            data-id={item?.siteId ? item?.siteId : item?.id}
                          >
                            {item?.name || item?.siteName}
                          </option>
                        ))
                      ) : (
                        <option value="">No Sites Available</option>
                      )}
                    </DropdownSelect>
                  </div>
                )}
              </div>
              {currentUserRole === USER_ROLE.ADMIN && (
                <div className="d-flex justify-content-between gap-4 mt-1">
                  <Button
                    size="large"
                    disabled={noAdminSites}
                    use="secondary"
                    className="add-site-button"
                    data-testid="userdetails_addSiteButton"
                    onClick={handleAddSite}
                  >
                    Add site
                  </Button>
                  <div className="w-50"></div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default UserDetails;
